import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { FaUserFriends } from 'react-icons/fa';

const VisitorCounter = () => {
    const [totalVisits, setTotalVisits] = useState(0);
    const [todayVisits, setTodayVisits] = useState(0);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        // Fetch Global Stats
        const globalUnsub = onSnapshot(doc(db, 'visitor_stats', 'global'), (doc) => {
            if (doc.exists()) {
                setTotalVisits(doc.data().totalVisits || 0);
            }
        });

        // Fetch Today's Stats
        const today = new Date().toISOString().split('T')[0];
        const dailyUnsub = onSnapshot(doc(db, 'visitor_stats', today), (doc) => {
            if (doc.exists()) {
                setTodayVisits(doc.data().count || 0);
            }
        });

        return () => {
            globalUnsub();
            dailyUnsub();
        };
    }, []);

    const styles = {
        container: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '0.8rem',
            color: 'white',
            background: 'rgba(255, 255, 255, 0.1)', // Glassmorphism background
            backdropFilter: 'blur(5px)', // Glassmorphism blur
            padding: '5px 12px',
            borderRadius: '20px',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            // marginLeft: '15px', // Removed for centering
            position: 'relative',
            cursor: 'default',
            transition: 'all 0.3s ease',
            boxShadow: isHovered ? '0 4px 15px rgba(0,0,0,0.2)' : 'none'
        },
        pulsingDot: {
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#4ade80', // Green
            boxShadow: '0 0 0 0 rgba(74, 222, 128, 0.7)',
            animation: 'pulse-green 2s infinite'
        },
        tooltip: {
            position: 'absolute',
            bottom: '120%',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0, 0, 0, 0.8)',
            padding: '8px 12px',
            borderRadius: '8px',
            fontSize: '0.75rem',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            opacity: isHovered ? 1 : 0,
            visibility: isHovered ? 'visible' : 'hidden',
            transition: 'opacity 0.2s, visibility 0.2s',
            zIndex: 10,
            textAlign: 'center'
        },
        tooltipArrow: {
            position: 'absolute',
            top: '100%',
            left: '50%',
            marginLeft: '-5px',
            borderWidth: '5px',
            borderStyle: 'solid',
            borderColor: 'rgba(0, 0, 0, 0.8) transparent transparent transparent'
        }
    };

    // Add keyframes for pulsing animation
    useEffect(() => {
        if (!document.getElementById('visitor-animations')) {
            const styleSheet = document.createElement("style");
            styleSheet.id = 'visitor-animations';
            styleSheet.innerText = `
                @keyframes pulse-green {
                    0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.7); }
                    70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(74, 222, 128, 0); }
                    100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(74, 222, 128, 0); }
                }
            `;
            document.head.appendChild(styleSheet);
        }
    }, []);

    // Helper to format number
    const fmt = (n) => n.toLocaleString('id-ID');

    return (
        <span
            className="visitor-counter-badge"
            style={styles.container}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Pulsing Dot */}
            <div style={styles.pulsingDot}></div>

            {/* Icon & Count */}
            <FaUserFriends style={{ fontSize: '0.9rem' }} />
            <span style={{ fontWeight: 500 }}>{fmt(totalVisits)}</span>

            {/* Tooltip Hover */}
            <div style={styles.tooltip}>
                <div>Total: <strong>{fmt(totalVisits)}</strong></div>
                <div style={{ marginTop: '2px', opacity: 0.9 }}>Hari ini: <strong>+{fmt(todayVisits)}</strong></div>
                <div style={styles.tooltipArrow}></div>
            </div>
        </span>
    );
};

export default VisitorCounter;
